// src/app/app.module.ts
import { Inject, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AppComponent } from './app.component';
import { LandingComponent } from './components/landing/landing.component';
import { AppRoutingModule } from './app.routing.module'; // Import your routing module
import { HomeComponent } from './components/home/home.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BuyerDetailsComponent } from './components/home/buyer-details/buyer-details.component';
import { BuyerTinComponent } from './components/home/buyer-tin/buyer-tin.component';
import { ReceiptDetailsComponent } from './components/home/receipt-details/receipt-details.component';
import { HttpinterceptorService } from './services/interceptors/httpinterceptor.service';
import { SubmissionSuccessComponent } from './components/home/submission-success/submission-success.component';
import { APP_CONFIG, appConfig } from './models/contant';
import { DeploymentCheckService } from './services/deployment-check.service';
import { DatePipe } from '@angular/common';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';
import { providePrimeNG } from 'primeng/config';
import { EyAuraPreset } from './theme/ey-aura-preset';

const nonce =
  document
    .querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')
    ?.content ?? '';
@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    HomeComponent,
    ReceiptDetailsComponent,
    BuyerTinComponent,
    BuyerDetailsComponent,
    SubmissionSuccessComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule, // Use your routing module here
    SharedModule,
    BrowserAnimationsModule,
    FormsModule,
    AccordionModule,
    ReactiveFormsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withXhr()),
    provideTranslateService({
      fallbackLang: 'EN',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      })
    }),
    providePrimeNG({
      theme: {
        preset: EyAuraPreset,
        options: {
          darkModeSelector: false
        },
        
      },
      csp: {
        nonce: nonce
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpinterceptorService,
      multi: true, // This ensures that the interceptor is added to the chain of interceptors
    },
    DatePipe,
    DeploymentCheckService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(@Inject(APP_CONFIG) public configData: any) {
    appConfig.appConfigService = configData;
    appConfig.updateConstant(configData);
  }
}
